/*
Purpose: Resolve test case selection and divide them into team mates
*/
import * as tc from "../services/tc-new";

import * as common from "./common";

// return the ordered list of test cases in this selection
async function resolveTestCaseSelection({ selection, projectId }) {
  let instanceConfig = {
    url: TC_URL,
    apiKey: window.API_KEY,
    projectID: projectId
  };

  let filters = [...selection.appliedFilters];
  // case 1: suite is selected
  if (selection.testSuites.length > 0) {
    // resolve suite selection to filter
    filters.push({
      field: "suite_id",
      filter: {
        value: {
          value: selection.testSuites
        }
      }
    });
  }

  // case 2: filters are selected
  //if (filters.length > 0) {
  const filterQuery = common.filtersToURL_New(filters);
  //}

  // call server and get ordered list of cases
  return new Promise((resolve, reject) => {
    /*
    call(tc.REFACTORfetchNew2, {
        action: "/test_cases/resolveTestCaseSelection",
        suffix: "&" + filterQuery
      });
      */

    resolve(
      tc.REFACTORfetch({
        instanceConfig: instanceConfig,
        action: "/test_cases/resolveTestCaseSelection",
        suffix:
          "&" + filterQuery + `&filterMatchType=${selection.filterMatchType}`
      })
    );
  });
}

export async function autoAssign({ testCaseSelection, teamMates, projectId }) {
  let assignMap = {};

  // case 2: multiple suites with relatively equal cases, multiple team
  /*
  const { data, headers } = yield call(tc.REFACTORfetchNew2, {
    action: "/test_cases/resolveTestCaseSelection",
    suffix: "&" + filterQuery
  });*/
  const tmp = await resolveTestCaseSelection({
    selection: testCaseSelection,
    projectId: projectId
  });
  const testCases = tmp.data;
  const remainder = testCases.length % teamMates.length;
  let workload = Math.floor(testCases.length / teamMates.length);

  let offset = 0;
  for (let i = 0; i < teamMates.length; i++) {
    let currentBatch = workload + offset;
    if (i == teamMates.length - 1) {
      // last batch so add remainder
      currentBatch += remainder;
    }
    assignMap["User_" + teamMates[i]] = {
      testCases: testCases.slice(offset, currentBatch)
    };
    offset += workload;
  }

  return assignMap;
}
